import { render, staticRenderFns } from "./TransienceCerebralIschemia.vue?vue&type=template&id=1b02a954&scoped=true&"
import script from "./TransienceCerebralIschemia.vue?vue&type=script&lang=js&"
export * from "./TransienceCerebralIschemia.vue?vue&type=script&lang=js&"
import style0 from "./TransienceCerebralIschemia.vue?vue&type=style&index=0&id=1b02a954&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02a954",
  null
  
)

export default component.exports